import BackgroundPattern from 'apps/customer/src/assets/icons/passkeys/background-pattern-decorative.svg';
import InfoIcon from 'apps/customer/src/assets/icons/passkeys/Info';
import { Button } from '@unified-checkout/design-system';

type EmptyPassKeyListProps = {
  handleAddPasskey: () => void;
  isPendingPasskeyRegister: boolean;
  isPendingVerifyPasskeyRegister: boolean;
};

function EmptyPassKeyList({
  handleAddPasskey,
  isPendingPasskeyRegister,
  isPendingVerifyPasskeyRegister,
}: EmptyPassKeyListProps) {
  return (
    <div
      className="relative w-full max-w-[480px] h-full  lg:h-[480px] mx-auto lg:-mt-20"
      style={{
        backgroundImage: `url(${BackgroundPattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[15%] lg:-translate-y-[11%] py-4 lg:py-0">
        {/* Icon stays exactly centered */}
        <div className="flex flex-col items-center">
          <InfoIcon />

          {/* Everything flows below the icon */}
          <div className="mt-5 flex flex-col items-center gap-8 text-center w-[320px]">
            <div className="flex flex-col gap-2">
              <p className="text-[#101828] text-xl font-semibold leading-[36px]">
                You have no passkey setup
              </p>

              <p className="text-[#475467] text-base leading-[28px]">
                Add a passkey to easily sign in without a password
              </p>
            </div>

            <div className="[&_button]:w-full w-full [&_button]:px-4 [&_button]:py-2.5  md:w-[386px]">
              <Button
                color="primary"
                text="Add passkey"
                size="md"
                type="button"
                onClickHandler={handleAddPasskey}
                disabled={
                  isPendingPasskeyRegister ||
                  isPendingVerifyPasskeyRegister
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyPassKeyList;